import { render, staticRenderFns } from "./joinup.vue?vue&type=template&id=27a6e8b3&scoped=true&"
import script from "./joinup.vue?vue&type=script&lang=js&"
export * from "./joinup.vue?vue&type=script&lang=js&"
import style0 from "./joinup.vue?vue&type=style&index=0&id=27a6e8b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a6e8b3",
  null
  
)

export default component.exports